<template>
  <div id="form-input" :class="inputClasses">
    <label :class="labelClassNames">{{ labelValue }} <i v-if="withHint" class="zmdi zmdi-help" v-tooltip.hover
                  :title="$t(`app.generals.emailHint`)"></i></label>
    <input
      v-if="!isThirdParty"
      :type="type"
      :class="classes"
      :disabled="inputDisabled"
      :required="required ? true : false"
      :placeholder="placeholder"
      @keypress="numbersOnly"
      @input="handleInput"
      :value="content"
    >
    <vuejs-datepicker
      :disabledDates="disabledDates"
      :disabled="inputDisabled"
      :class="classNames"
      v-if="isDatePicker"
      @selected="handleChange"
      :value="content"
    ></vuejs-datepicker>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  name: "FormInput",
  components: {
    "vuejs-datepicker": Datepicker
  },
  props: {
    type: {
      type: [String],
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    classNames: {
      type: String,
      default: ""
    },
    labelClassNames: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String,Number],
      default: ""
    },
    labelValue: {
      type: String,
      default: ""
    },
    validationMethod: {
      type: Function,
      value: Object
    },
    inputDisabled: {
      type: Boolean,
      default: false
    },
    withHint: {
      type: Boolean,
      default: false
    },
    hintText: {
      type: String,
      default: ""
    },
    inputClasses: {
      type: String,
      default: ""
    }
  },
  created() {},
  data() {
    return {
      content: this.value,
      isValid: true,
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
    };
  },
  computed: {
    isThirdParty() {
      if (this.isDatePicker) {
        return true;
      }
      return false;
    },
    isDatePicker() {
      return this.type === "date";
    },
    classes() {
      if (this.isValid) {
        return this.classNames;
      } else {
        return `${this.classNames} invalid`;
      }
    }
  },
  methods: {
    handleInput(e) {
      if (typeof e.data === "number") {
        e.preventDefault();
      }
      this.$emit("input", e.target.value);
      if (this.validationMethod) {
        this.isValid = this.validationMethod(e.target.value);
      }
    },
    numbersOnly(evt) {
      if (this.type !== 'number') {
        return true;
      };
      const pattern=/[0-9]+/;
      if (!pattern.test(evt.key)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleChange(e) {
      this.$emit("inputChange", e.toString());
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.content = this.value;
    }
  }
};
</script>

<style lang="scss">
#form-input {
  .disabled-date-picker {
    border: rgb(204, 204, 204) 1px solid;
    padding: 0;
    /deep/ input {
      padding: 10px 12px;
      cursor: not-allowed;
      background-color: #eee;
    }
  }
  input {
    text-transform: none;
  }
  input::-webkit-input-placeholder {
    text-transform: none;
  }
  input::-moz-placeholder {
    text-transform: none;
  }
  height: 100%;
  .invalid {
    border: 1px solid #ff6565;
  }
  .vdp-datepicker {
    input {
      border: none;
      outline: none;
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/inputs/FormInput.vue